import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import {
  xdlColorTextOnLight,
  spaceL,
  spaceXXL,
  spaceXL,
} from '@xing-com/tokens';
import { Hero as BaseHero } from '@xing-com/typography';

const Hero = styled(BaseHero)`
  padding-top: ${spaceXXL};
  text-align: center;
  color: ${xdlColorTextOnLight};
  margin: 0 20px ${spaceXL} 20px;
  text-wrap: balance;

  @media ${mediaConfined} {
    padding-top: ${spaceL};
  }
`;

export const Title: React.FC = () => {
  return (
    <Hero size="small" sizeConfined="medium">
      <FormattedMessage id="JOBS_FIND_JOBS_HEADER_TITLE" />
    </Hero>
  );
};
